import JSONAPIClient from '../JSONAPIClient'

JSONAPIClient.define(
  'statement_import',
  { task_id: '' }
)
